export default __webpack_public_path__ + "static/media/07.1ff7580a.jpg";